import { useRef, useEffect } from "react";

// Hook
export function usePrevious<T>(value: T, setInitialValue?: boolean) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef<T | undefined>(setInitialValue ? value : undefined);

    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes

    // Return previous value (happens before update in useEffect above)
    return ref.current;
}